import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AgentApi, AgentApiImpl } from './apis';
import { SuperAgentApi, SuperAgentApiImpl } from './apis/super-agent';

export const agentContainer = new ContainerModule((bind) => {
  bind(AgentApi).to(AgentApiImpl);
  bind(SuperAgentApi).to(SuperAgentApiImpl);
});
